__turbopack_context__.v({
  "account_button": "styles-module-scss-module__8WHucq__account_button",
  "account_link": "styles-module-scss-module__8WHucq__account_link",
  "account_links": "styles-module-scss-module__8WHucq__account_links",
  "desktop_navigation": "styles-module-scss-module__8WHucq__desktop_navigation",
  "dropdown_link_is_active": "styles-module-scss-module__8WHucq__dropdown_link_is_active",
  "header": "styles-module-scss-module__8WHucq__header",
  "home_link": "styles-module-scss-module__8WHucq__home_link",
  "is_white": "styles-module-scss-module__8WHucq__is_white",
  "logo_class": "styles-module-scss-module__8WHucq__logo_class",
  "logo_container": "styles-module-scss-module__8WHucq__logo_container",
  "main_navigation_container": "styles-module-scss-module__8WHucq__main_navigation_container",
  "menu_button_container": "styles-module-scss-module__8WHucq__menu_button_container",
  "menu_close_button": "styles-module-scss-module__8WHucq__menu_close_button",
  "menu_open_button": "styles-module-scss-module__8WHucq__menu_open_button",
  "mobile_account_heading": "styles-module-scss-module__8WHucq__mobile_account_heading",
  "mobile_account_menu_inner": "styles-module-scss-module__8WHucq__mobile_account_menu_inner",
  "mobile_navigation": "styles-module-scss-module__8WHucq__mobile_navigation",
  "navigation_container": "styles-module-scss-module__8WHucq__navigation_container",
  "navigation_header": "styles-module-scss-module__8WHucq__navigation_header",
  "navigation_is_showing": "styles-module-scss-module__8WHucq__navigation_is_showing",
  "no_sign_in_buttons": "styles-module-scss-module__8WHucq__no_sign_in_buttons",
  "screen_reader_title": "styles-module-scss-module__8WHucq__screen_reader_title",
});
